<template>
  <svg id="draw_flow" :class="{'dark':skinType}" viewBox="0 0 1000 450">
    <defs>
      <marker
        id="arrow1"
        viewBox="0 0 6 6"
        refX="5"
        refY="3"
        markerUnits="strokeWidth"
        markerWidth="6"
        markerHeight="6"
        orient="auto"
      >
        <path d="M 0 0 L 6 3 L 0 6 z" fill="gray" stroke-width="0"></path>
      </marker>
      <marker
        id="arrow2"
        viewBox="0 0 6 6"
        refX="5"
        refY="3"
        markerUnits="strokeWidth"
        markerWidth="6"
        markerHeight="6"
        orient="auto"
      >
        <path d="M 0 0 L 6 3 L 0 6 z" fill="#ff3300" stroke-width="0"></path>
      </marker>
      <marker
        id="arrow3"
        viewBox="0 0 6 6"
        refX="5"
        refY="3"
        markerUnits="strokeWidth"
        markerWidth="6"
        markerHeight="6"
        orient="auto"
      >
        <path d="M 0 0 L 6 3 L 0 6 z" fill="#225ee1" stroke-width="0"></path>
      </marker>
    </defs>
    <g
      id="90726096-c80a-35dd-e32c-e50bfc6d64c3"
      from="86,154"
      to="162,153.5"
      style="cursor: pointer"
    >
      <path
        visibility="hidden"
        stroke-width="9"
        fill="none"
        stroke="white"
        d="M 86 154 L 162 153.5"
        pointer-events="stroke"
      ></path>
      <path
        d="M 86 154 L 162 153.5"
        stroke-width="2"
        stroke-linecap="round"
        fill="none"
        stroke="gray"
        marker-end="url(#arrow1)"
      ></path>
      <text text-anchor="middle" x="124" y="148.75" style="cursor: text"></text>
    </g>
    <g
      id="2089f3c6-6e6d-7e77-3a47-682bc653d33f"
      from="312,153.5"
      to="400,152.5"
      style="cursor: pointer"
    >
      <path
        visibility="hidden"
        stroke-width="9"
        fill="none"
        stroke="white"
        d="M 312 153.5 L 400 152.5"
        pointer-events="stroke"
      ></path>
      <path
        d="M 312 153.5 L 400 152.5"
        stroke-width="2"
        stroke-linecap="round"
        fill="none"
        stroke="gray"
        marker-end="url(#arrow1)"
      ></path>
      <text text-anchor="middle" x="356" y="148" style="cursor: text"></text>
    </g>
    <g
      id="832e7892-8d32-0715-c579-b38f40a3b398"
      from="237,121"
      to="907,306"
      style="cursor: pointer"
    >
      <path
        visibility="hidden"
        stroke-width="9"
        fill="none"
        stroke="white"
        d="M 237 121 L 237 76.48214340209961 L 907 76.48214340209961 L 907 306"
        pointer-events="stroke"
      ></path>
      <path
        d="M 237 121 L 237 76.48214340209961 L 907 76.48214340209961 L 907 306"
        stroke-width="2"
        stroke-linecap="round"
        fill="none"
        stroke="#ff3300"
        marker-end="url(#arrow2)"
      ></path>
      <text
        text-anchor="middle"
        x="572"
        y="71.48214340209961"
        style="cursor: text"
        :fill="skinType?'white':'black'"
      >
        否
      </text>
    </g>
    <g
      id="e2f84a86-2b88-b6d9-5000-243393632255"
      from="550,152.5"
      to="641,150.5"
      style="cursor: pointer"
    >
      <path
        visibility="hidden"
        stroke-width="9"
        fill="none"
        stroke="white"
        d="M 550 152.5 L 641 150.5"
        pointer-events="stroke"
      ></path>
      <path
        d="M 550 152.5 L 641 150.5"
        stroke-width="2"
        stroke-linecap="round"
        fill="none"
        stroke="gray"
        marker-end="url(#arrow1)"
      ></path>
      <text
        text-anchor="middle"
        x="595.5"
        y="146.5"
        style="cursor: text"
      ></text>
    </g>
    <g
      id="836356e4-4421-e9a1-fc39-cb1cffc86612"
      from="475,185"
      to="237,186"
      style="cursor: pointer"
    >
      <path
        visibility="hidden"
        stroke-width="9"
        fill="none"
        stroke="white"
        d="M 475 185 L 475 217.47916793823242 L 237 217.47916793823242 L 237 186"
        pointer-events="stroke"
      ></path>
      <path
        d="M 475 185 L 475 217.47916793823242 L 237 217.47916793823242 L 237 186"
        stroke-width="2"
        stroke-linecap="round"
        fill="none"
        stroke="#ff3300"
        marker-end="url(#arrow2)"
      ></path>
      <text
        text-anchor="middle"
        x="356"
        y="212.47916793823242"
        style="cursor: text"
        :fill="skinType?'white':'black'"
      >
        否
      </text>
    </g>
    <g
      id="fcccfe23-012e-f569-37e8-a39276e6fdac"
      from="791,150.5"
      to="235,296"
      style="cursor: pointer"
    >
      <path
        visibility="hidden"
        stroke-width="9"
        fill="none"
        stroke="white"
        d="M 791 150.5 L 791 258.22321701049805 L 235 258.22321701049805 L 235 296"
        pointer-events="stroke"
      ></path>
      <path
        d="M 791 150.5 L 791 258.22321701049805 L 235 258.22321701049805 L 235 296"
        stroke-width="2"
        stroke-linecap="round"
        fill="none"
        stroke="gray"
        marker-end="url(#arrow1)"
      ></path>
      <text
        text-anchor="middle"
        x="513"
        y="253.22321701049805"
        style="cursor: text"
      ></text>
    </g>
    <g
      id="ea82af7b-9a81-bf05-dbd0-821f798917cc"
      from="716,183"
      to="237,186"
      style="cursor: pointer"
    >
      <path
        visibility="hidden"
        stroke-width="9"
        fill="none"
        stroke="white"
        d="M 716 183 L 716 237.47916793823242 L 237 237.47916793823242 L 237 186"
        pointer-events="stroke"
      ></path>
      <path
        d="M 716 183 L 716 237.47916793823242 L 237 237.47916793823242 L 237 186"
        stroke-width="2"
        stroke-linecap="round"
        fill="none"
        stroke="#ff3300"
        marker-end="url(#arrow2)"
      ></path>
      <text
        text-anchor="middle"
        x="476.5"
        y="232.47916793823242"
        style="cursor: text"
        :fill="skinType?'white':'black'"
      >
        否
      </text>
    </g>
    <g
      id="d221bafc-0c19-39ee-4578-fa52a21dc236"
      from="310,328.5"
      to="399,329.5"
      style="cursor: pointer"
    >
      <path
        visibility="hidden"
        stroke-width="9"
        fill="none"
        stroke="white"
        d="M 310 328.5 L 399 329.5"
        pointer-events="stroke"
      ></path>
      <path
        d="M 310 328.5 L 399 329.5"
        stroke-width="2"
        stroke-linecap="round"
        fill="none"
        stroke="gray"
        marker-end="url(#arrow1)"
      ></path>
      <text text-anchor="middle" x="354.5" y="324" style="cursor: text"></text>
    </g>
    <g
      id="b757aee9-eb10-64ff-73d1-44317f8f17fc"
      from="549,329.5"
      to="640,329.5"
      style="cursor: pointer"
    >
      <path
        visibility="hidden"
        stroke-width="9"
        fill="none"
        stroke="white"
        d="M 549 329.5 L 640 329.5"
        pointer-events="stroke"
      ></path>
      <path
        d="M 549 329.5 L 640 329.5"
        stroke-width="2"
        stroke-linecap="round"
        fill="none"
        stroke="gray"
        marker-end="url(#arrow1)"
      ></path>
      <text
        text-anchor="middle"
        x="594.5"
        y="324.5"
        style="cursor: text"
      ></text>
    </g>
    <g
      id="fea91053-3b22-4e31-d78d-1e4769a2eda4"
      from="790,329.5"
      to="881,332"
      style="cursor: pointer"
    >
      <path
        visibility="hidden"
        stroke-width="9"
        fill="none"
        stroke="white"
        d="M 790 329.5 L 881 332"
        pointer-events="stroke"
      ></path>
      <path
        d="M 790 329.5 L 881 332"
        stroke-width="2"
        stroke-linecap="round"
        fill="none"
        stroke="gray"
        marker-end="url(#arrow1)"
      ></path>
      <text
        text-anchor="middle"
        x="835.5"
        y="325.75"
        style="cursor: text"
      ></text>
    </g>
    <ProcessEnd
      :endInfo="{ name: '开始', status: 0 }"
      transform="translate(30,127)"
    ></ProcessEnd>
    <ProcessItem
      :processInfo="managedProcessList[0]"
      transform="translate(160,122)"
    ></ProcessItem>
    <ProcessItem
      :processInfo="managedProcessList[1]"
      transform="translate(400,122)"
    ></ProcessItem>
    <ProcessItem
      :processInfo="managedProcessList[2]"
      transform="translate(640,122)"
    ></ProcessItem>
    <ProcessItem
      :processInfo="managedProcessList[3]"
      transform="translate(160,300)"
    ></ProcessItem>
    <ProcessItem
      :processInfo="managedProcessList[4]"
      transform="translate(400,300)"
    ></ProcessItem>
    <ProcessItem
      :processInfo="managedProcessList[5]"
      transform="translate(640,300)"
    ></ProcessItem>
    <ProcessEnd
      :endInfo="{ name: '结束', status: 1 }"
      transform="translate(880,308)"
    ></ProcessEnd>
  </svg>
</template>
<script>
import ProcessItem from '@/components/equipment-operational/components/dialog/process-item.vue';
import ProcessEnd from '@/components/equipment-operational/components/dialog/process-end.vue';
import clone from '@/utils/clone';

export default {
  name: 'process-info',
  props: {
    selectProcessInfo: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      processList: [
        {
          name: '派单',
          status: 0,
        },
        {
          name: '主任审批',
          status: 0,
        },
        {
          name: '开始维保',
          status: 0,
        },
        {
          name: '维保完成',
          status: 0,
        },
        {
          name: '确认完成',
          status: 0,
        },
        {
          name: '审核',
          status: 0,
        },
      ],
    };
  },
  computed: {
    skinType() {
      return this.$store.getters.skinType;
    },
    managedProcessList() {
      const list = clone(this.processList);
      console.log('this.selectProcessInfo', this.selectProcessInfo);
      for (let i = 0; i < list.length; i += 1) {
        list[i].status = 2;
        if (list[i].name === (this.selectProcessInfo.F_TaskName ? this.selectProcessInfo.F_TaskName
          : this.selectProcessInfo.F_NodeName)) {
          list[i].status = 1;
          break;
        }
      }
      console.log('managedList', list);
      return list;
    },
  },
  components: {
    ProcessItem,
    ProcessEnd,
  },
  methods: {},
};
</script>
<style scoped>
.draw-flow {
  width: 100%;
  max-width: 100%;
}
</style>
